import { createContext, useContext } from "react"

export type ToastContextValue = {
	showChangesSaved(changeName: string): void
	showPublished(productName: string): void
	showDeleted(deletedName: string): void
	showError(error: string): void
	showSuccess(success: string): void
	setUnsavedChanges(onSave: () => Promise<boolean>): void
	setDiscardableUnsavedChanges(args: { saveLabel?: string; onSave(): Promise<boolean>; onDiscard(): void }): void
	clearUnsavedChanges(): void
}

export const ToastContext = createContext<ToastContextValue>(undefined!)

export function useToast() {
	return useContext(ToastContext)
}

// Kept apart from ToastContext so pages whose effects depend on useToast() don't rerun when the bar opens or closes.
export const UnsavedChangesOpenContext = createContext(false)

// True once the unsaved changes bar is open and the page has reserved room for it.
export function useIsUnsavedChangesOpen() {
	return useContext(UnsavedChangesOpenContext)
}
